import React, { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import "../css/adminDonation.css";
import { toast } from "react-toastify";

const AdminDonation = () => {
  const url = process.env.REACT_APP_BASE_URL;
  const [donations, setDonations] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [donationsPerPage] = useState(15); // Number of donations per page
  const [isImageOpen, setIsImageOpen] = useState(false);
  const [currentOpenImage, setCurrentOpenImage] = useState("");


  const [filters, setFilters] = useState({
    q: "", //search
    startDate: "",
    endDate: "",
    status: "",
    donationType: "",
  });

  // Fetch donations data when the component mounts
  useEffect(() => {
    console.log(filters);
    const fetchDonations = async () => {
      try {
        const params = new URLSearchParams();

        // Add filters to the query string
        Object.keys(filters).forEach((key) => {
          if (filters[key]) params.append(key, filters[key]);
        });
      console.log("params to search ",params.toString())
        const response = await axios.get(
          `${url}/api/donations/donations?${params.toString()}`
        );
        setDonations(response.data); // Set the data to state
      } catch (error) {
        console.error("Error fetching donation data:", error);
      }
    };

    fetchDonations();
  }, [filters]);

  // formated date
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    });
  };

  // Function to export donations data to an Excel file
 /*
  const exportToExcel = () => {
    const filteredDonations = donations.map(({ _id, __v, ...rest }) => rest);
    const ws = XLSX.utils.json_to_sheet(filteredDonations);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Donations");
    XLSX.writeFile(wb, "donations.xlsx");
  };
 */

// here is fucntion that will the export the records
//  based on filter if filter is not applid all records are exported...
const exportToExcel = async () => {
  try {
    const params = new URLSearchParams();

    // Add all current filters to the query string
    Object.keys(filters).forEach((key) => {
      if (filters[key]) params.append(key, filters[key]);
    });

    // Fetch all donation records (no pagination)
    const response = await axios.get(
      `${url}/api/donations/donations?${params.toString()}`
    );

    // Map data to exclude unnecessary fields
    const allDonations = response.data.map(({ _id, __v, ...rest }) => rest);

    // Generate Excel file
    const ws = XLSX.utils.json_to_sheet(allDonations);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Donations");
    XLSX.writeFile(wb, "donations.xlsx");
  } catch (error) {
    console.error("Error exporting data:", error);
    alert("Failed to export data. Please try again.");
  }
};

 // Get current donations for the current page
  const indexOfLastDonation = currentPage * donationsPerPage;
  const indexOfFirstDonation = indexOfLastDonation - donationsPerPage;
  const currentDonations = donations.slice(
    indexOfFirstDonation,
    indexOfLastDonation
  );

  // Handle pagination logic
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate total pages
  const totalPages = Math.ceil(donations.length / donationsPerPage);

  // close  full image after click on X
  function closeFullImg() {
    setIsImageOpen(false);
  }
  // open full image after click on image
  function openFullImg(e, currentImage) {
    setIsImageOpen(true);
    setCurrentOpenImage(currentImage);
  }

  //  handle state change
  const handleStatusChange = async (id, newStatus) => {
    console.log("status in handle change method ", id, newStatus);
    let response = null;
    try {
      if (newStatus === "Pending") {
        toast.error("You Can't Modify Status to Pending")
        return;
      }
      if (newStatus === "Approved") {
        response = await axios.post(`${url}/api/donations/approve/${id}`);
      }

      if (newStatus === "Rejected") {
        response = await axios.post(`${url}/api/donations/reject/${id}`);
      }
      console.log("Response afte approve", response);
      const updatedDonation = response.data.donation;
      setDonations((prev) =>
        prev.map((donation) =>
          donation._id === id
            ? { ...donation, status: updatedDonation.status }
            : donation
        )
      );
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Error updating status.");
    }
  };

  useEffect(() => {
    console.log(isImageOpen);
  }, [isImageOpen]);

  return (
    <div>
      {/* to open full image popup  */}
      <div
        className={
          isImageOpen ? "payment-Full-image-open" : "payment-Full-image"
        }
      >
        <img src={`${url}/payimg/${currentOpenImage}`} alt="" />
        <span onClick={closeFullImg}>X</span>
      </div>

      {/* <input type="text" name="search" placeholder="Search" onChange={(e)=>{setQuery(e.target.value)}} /> */}
      <h1>Donations</h1>

      {/* all filters logic here  */}
      <div className="filters">
        <input
          type="text"
          placeholder="Search"
          value={filters.q}
          onChange={(e) => setFilters({ ...filters, q: e.target.value })}
        />
        <div className="date-dropdown-container">
          {/* date filters */}
          <div className="date">
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) =>
                setFilters({ ...filters, startDate: e.target.value })
              }
            />
            <span>Form</span>
            <input
              type="date"
              value={filters.endDate}
              min={filters.startDate}
              onChange={(e) =>
                setFilters({ ...filters, endDate: e.target.value })
              }
            />
          </div>
          <div className="option-dropdown">
            <select
              value={filters.status}
              onChange={(e) =>
                setFilters({ ...filters, status: e.target.value })
              }
            >
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>

            <select
              value={filters.donationType}
              onChange={(e) =>
                setFilters({ ...filters, donationType: e.target.value })
              }
            >
              <option value="">All Types</option>
              <option value="अभिषेक_देणगी">अभिषेक_देणगी</option>
              <option value="वेदपाठशाला_देणगी">वेदपाठशाला_देणगी</option>
              <option value="अन्नदान_देणगी">अन्नदान_देणगी</option>
              <option value="गोसेवा_देणगी">गोसेवा_देणगी</option>
              <option value="इमारत_निधी">इमारत_निधी</option>
              <option value="सामाजिक_उपक्रम_देणगी">सामाजिक_उपक्रम_देणगी</option>
              <option value="अन्य">अन्य</option>
            </select>
          </div>
          <button onClick={exportToExcel} className="export-btn">
            {" "}
            Export to Excel{" "}
          </button>
        </div>
      </div>

      <div className="donation-table-container">
        <table className="donation-table">
          <thead>
            <tr>
              <th>Sr.no</th>
              <th>Date</th>
              <th>Name</th>
              <th>Gotra</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Pincode</th>
              <th>State</th>
              <th>City</th>
              <th>Address</th>
              <th>Donation Type</th>
              <th>Sub Donation Type</th>
              <th>Denagi</th>
              <th>Amount</th>
              <th>utr</th>
              <th>imagePayment</th>
              <th>paymentMethod</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentDonations.map((donation, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{formatDate(donation.created)}</td>
                <td>{donation.name}</td>
                <td>{donation.gotra || "N/A"}</td>
                <td>{donation.email || "N/A"}</td>
                <td>{donation.phNumber || "N/A"}</td>
                <td>{donation.pincode || "N/A"}</td>
                <td>{donation.state || "N/A"}</td>
                <td>{donation.city || "N/A"}</td>
                <td>{donation.address || "N/A"}</td>
                <td>{donation.donationType || "N/A"}</td>
                <td>{donation.subDonationType || "N/A"}</td>
                <td>{donation.denagi || "N/A"}</td>
                <td>{donation.amount || "N/A"}</td>
                <td>{donation.utr || "N/A"}</td>
                <td>
                  {donation.imagePayment ? (
                    <img
                      src={`${url}/payimg/${donation.imagePayment}`}
                      alt="Payment"
                      onClick={(e) => {
                        openFullImg(e, donation.imagePayment);
                      }}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        borderRadius: "5px",
                      }}
                    />
                  ) : (
                    "N/A"
                  )}
                </td>
                <td>{donation.paymentMethod || "N/A"}</td>
                <td>
                  <select
                    value={donation.status}
                    onChange={(e) =>
                      handleStatusChange(donation._id, e.target.value)
                    }
                  >
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          onClick={() => paginate(currentPage - 1)}
          className={`pagination-btn ${currentPage === 1 ? "disabled" : ""}`}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            onClick={() => paginate(index + 1)}
            className={`pagination-btn ${
              currentPage === index + 1 ? "active" : ""
            }`}
          >
            {index + 1}
          </button>
        ))}
        <button
          onClick={() => paginate(currentPage + 1)}
          className={`pagination-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default AdminDonation;
